import { UIHeading1 } from '@cian/ui-kit';

import { type FC, type ReactNode } from 'react';

import { Layout } from 'shared/components/Layout';

import styles from './style.css';

interface IPurchaseLayoutProps {
  title: string;
  list: ReactNode;
}

export const PurchaseLayout: FC<IPurchaseLayoutProps> = ({ title, list }) => {
  return (
    <section className={styles['container']}>
      <Layout>
        <div className={styles['wrapper']}>
          <div className={styles['title']}>
            <UIHeading1>{title}</UIHeading1>
          </div>
          {list}
        </div>
      </Layout>
    </section>
  );
};
